// A megaphone — the broadcast (org-wide takeover) affordance. Same loose,
// round-stroke language as NavIcons, currentColor throughout.
import type { SVGProps } from 'react';

export function BroadcastIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={18}
      height={18}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      <path d="M4 9.5v5a1.5 1.5 0 0 0 1.5 1.5H7l1.2 3.4a1 1 0 0 0 .95.66h.6a1 1 0 0 0 1-1V16" />
      <path d="M7 9.5 18 5v14L7 14.5z" />
      <path d="M18 9a3 3 0 0 1 0 6" opacity="0.7" />
    </svg>
  );
}
